/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import get from 'lodash/get';
import * as Styles from './index.style';
import { keyColors } from '../../../styles/colors';
import Spacer from '../../ui/Spacer';
import { Column, Container, Row } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import createButtonCss from '../../ui/Button/Button';
import DotComponent from '../../ui/DotComponent';
import { browseresionContainer } from './index.style';

import compose from 'lodash/fp/compose';
class SEOBanner extends Component {
  state = { prefixURL: '' };
  componentDidMount = () => {
    if (this.isDedicatedPage()) {
      document.querySelector('footer').style.marginTop = '0px';
    }

    // this.preparePrifixURL();
  };

  // preparePrifixURL = () => {
  //   this.setState({
  //     prefixURL:
  //       window.location.href.slice(-1) === '/'
  //         ? window.location.href.slice(0, -1)
  //         : window.location.href,
  //   });
  // };

  isDedicatedPage = () => {
    const getAllSection = document.querySelectorAll('section');

    return getAllSection && getAllSection.length === 1;
  };

  render() {
    const { prefixURL } = this.state;
    console.log('Banner', this.props);
    const Heading = get(this.props.fields, 'Heading.value', '');
    const Summary = get(this.props.fields, 'Summary.value', '');
    const Image = get(this.props.fields, 'Image.value', '');
    const CTA = get(this.props.fields, 'RegionCTA.value.href', '');
    const CTAText = get(this.props.fields, 'RegionCTA.value.text', '');

    return (
      <Spacer
        backgroundColor={keyColors.brown10}
        marginCss={Styles.containerMarginCss}
        paddingCss={Styles.containerPaddingCss}
      >
        <Container className={Styles.backgroundCircle}>
          <Row css={browseresionContainer}>
            <Column className="ctabtn" cols={{ sm: 12, md: 5, lg: 7, xl: 8 }}>
              <div className="textArea">
                <h2>
                  {Heading}
                  <DotComponent />
                </h2>
                <p>{Summary}</p>
              </div>
            </Column>
            <Column className="ctabtn" cols={{ sm: 12, md: 3, lg: 5, xl: 4 }}>
              <div>
                <a
                  className="ctabutton"
                  href={CTA}
                  css={[createButtonCss()]}
                >
                  {CTAText}
                </a>
              </div>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

export default SEOBanner;
